import { supabase } from '@/src/core/config/supabase';
import { logger } from '@/src/core/utils';
import { ModerateContentUseCase } from './ModerateContentUseCase';

export class UpdateProfileUseCase {
  constructor(private moderateContent: ModerateContentUseCase) {}

  async execute(params: {
    userId: string;
    fullName: string;
    bio: string;
    avatarUrl: string;
  }): Promise<void> {
    const { userId, fullName, bio, avatarUrl } = params;

    // Moderate text fields before writing
    if (fullName.trim()) {
      await this.moderateContent.execute(fullName, 'username', userId);
    }
    if (bio.trim()) {
      await this.moderateContent.execute(bio, 'profile_bio', userId);
    }

    const { data: { session } } = await supabase.auth.getSession();
    if (!session) throw new Error('User not authenticated');

    const { error } = await supabase.auth.updateUser({
      data: {
        full_name: fullName.trim(),
        bio: bio.trim(),
        avatar_url: avatarUrl,
      },
    });

    if (error) {
      logger.error('UpdateProfile', 'Failed to update profile', { error });
      throw error;
    }

    logger.info('UpdateProfile', 'Profile updated successfully', { userId });
  }
}
